import { render, staticRenderFns } from "./RcWidgetLiveResultsBeta1.vue?vue&type=template&id=24afaa56&"
import script from "./RcWidgetLiveResultsBeta1.vue?vue&type=script&lang=js&"
export * from "./RcWidgetLiveResultsBeta1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports